import { useGetVerificationCodeBatches } from "@bvhi/backend-api/apis/api/verification-code/verification-code";
import { BVHIErrorsAlerts } from "../../../../../components/bvhi-error-alerts";
import { Route } from "../../../../../routes/_main/app/verification-codes.index";

export const VerificationCodeErrorAlerts = () => {
  const searchParams = Route.useSearch();
  const { error } = useGetVerificationCodeBatches(searchParams);

  return <BVHIErrorsAlerts error={error} />;
};
